import {
 IProductCatalogue,
 IProductVariant,
} from 'models/ProductManagement'
import {ToggleButton} from 'helpers/ui-components/ToggleButton'
import {formatNumberForDisplay} from 'utils/helper'
import {getVariantActiveStatus} from './productCatalogueUtils'
type VariantRowsProps = {
 product: IProductCatalogue
 isDistributorAdmin: boolean
 isProductEditing: boolean

 editedPrices: Record<number, string>
 setEditedPrice: (variantId: number, value: string) => void
 onToggleActive: (
  variant: IProductVariant,
  productName: string
 ) => void
 canEditActive: boolean
}

const VariantRows = ({
 product,
 isDistributorAdmin,
 isProductEditing,
 editedPrices,
 setEditedPrice,
 onToggleActive,
 canEditActive,
}: VariantRowsProps) => {
 return (
  <table className='w-full'>
   <colgroup>
    <col className='w-[12%]' />
    <col className='w-[28%]' />
    <col className='w-[15%]' />
    <col className='w-[20%]' />
    <col className='w-[15%]' />
    <col className='w-[10%]' />
   </colgroup>
   <tbody>
    {product.variants.map((variant) => {
     const displayPrice = isDistributorAdmin
      ? variant.seller_price
      : variant.variant_price

     const isActive = getVariantActiveStatus(
      variant,
      isDistributorAdmin
     )

     return (
      <tr
       key={variant.product_variant_id}
       className={`border-t border-[#E6EBF0] text-sm text-[#33393D]`}
      >
       <td className='py-3 px-2'></td>
       <td className='py-3 px-2 pl-8'>
        {variant.product_sku_name}
       </td>
       <td className='py-3 px-2'>
        <ToggleButton
         disabled={!canEditActive}
         onBtnClass='bg-[#4E83E4]'
         checked={isActive}
         onChange={() => {
          if (canEditActive) {
           onToggleActive(variant, product.product_name)
          }
         }}
        />
       </td>
       <td className='py-3 px-2'>
        <i className='fa fa-inr pr-0.5'></i>
        {formatNumberForDisplay(variant.mrp)}
       </td>
       <td className='py-3 px-2'>
        {isProductEditing ? (
         <div className='flex items-center border border-[#4E83E4] rounded-lg px-2 py-1 bg-[#F5FAFF]'>
          <i className='fa fa-inr pr-1 text-[#5A6066]'></i>
          <input
           type='text'
           className='w-full text-sm outline-none bg-transparent'
           value={
            editedPrices[variant.product_variant_id] ?? ''
           }
           onChange={(e) =>
            setEditedPrice(
             variant.product_variant_id,
             e.target.value
            )
           }
          />
         </div>
        ) : (
         <div>
          <i className='fa fa-inr pr-0.5'></i>
          {formatNumberForDisplay(displayPrice)}
         </div>
        )}
       </td>
       <td className='py-3 px-2'></td>
      </tr>
     )
    })}
   </tbody>
  </table>
 )
}

export default VariantRows
